import React from 'react';
import PropTyes from 'prop-types';

import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const pageTitleStyles = makeStyles(({ breakpoints }) => ({
  root: {
    margin: '40px 0',
    '& h1': {
      fontSize: 42,
      [breakpoints.down('sm')]: {
        fontSize: 32,
      },
      fontWeight: 'bold',
      lineHeight: '100%',
    },
  },
}));

export default function PageTitle(props) {
  const { title } = props;
  const classes = pageTitleStyles();

  return (
    <Box className={classes.root}>
      <Typography variant="h1">{title}</Typography>
    </Box>
  );
}

PageTitle.propTypes = {
  title: PropTyes.string,
};

PageTitle.defaultProps = {
  title: 'Título da página',
};
